import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'
import { publicRequest } from '../../_network/request'
import { subscriptionsURLs } from '../../_network/apiUrls'
import isender_invoicing from '../../assets/images/isender_invoicing.png'
import isender_design from '../../assets/images/isender_design.png'
import isender_web from '../../assets/images/isender_web.png'
import parse from 'html-react-parser'
import CustomHomeDivider from '../_common/CustomHomeDivider'
import HomeSubscriptionItem from './HomeSubscriptionItem'
import CustomSlickSlider from '../_common/CustomSlickSlider'

const HomeProductISender = () => {
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const [subscriptionPackagesData, setSubscriptionPackagesData] = useState([])
  const [subscriptionGroupsData, setSubscriptionGroupsData] = useState([])
  const [subscriptions, setSubscriptions] = useState([])
  const [subscriptionsSliderData, setSubscriptionsSliderData] = useState([])
  const [subscriptionsSliderSlidesToShow, setSubscriptionsSliderSlidesToShow] = useState(0)

  const subscriptionSliderArrows = {
    leftIcon: <ArrowBackIcon fontSize='large' />,
    rightIcon: <ArrowForwardIcon fontSize='large' />,
    leftStyle: {
      width: '50px',
      height: '50px',
      border: `${theme.palette.oxfordBlue} 2px solid`,
      borderRadius: '25px',
      color: theme.palette.oxfordBlue,
      position: 'absolute',
      top: '45%',
      left: '-50px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },    
    rightStyle: {
      width: '50px',
      height: '50px',
      border: `${theme.palette.oxfordBlue} 2px solid`,
      borderRadius: '25px',
      color: theme.palette.oxfordBlue,
      position: 'absolute',
      top: '45%',
      right: '-50px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }

  const pageLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '28px',
    fontWeight: '500',
  }

  const adminUiWrapperStyle = {
    minHeight: '500px',
    background: theme.palette.aliceBlue,
    padding: '20px',
    borderTop: `${theme.palette.vodka} 1px solid`,
  }

  const imageStyle = {
    maxWidth: '100%',
    height: 'auto',
  }

  const adminUiLabel = {
    color: theme.palette.violetsAreBlue,
    paddingBottom: '30px',
    fontWeight: '500',
    fontSize: '22px',
  }

  const adminUiDescription = {
    fontSize: '20px',
  }

  const customerUiWrapperStyle = {
    minHeight: '500px',
    background: theme.palette.oxfordBlue,
    padding: '20px',
  }

  const customerUiDescription = {
    fontSize: '20px',
    color: 'white',
  }

  const pricesLabel = {
    height: '100px',
    background: 'white',
    fontSize: '40px',
    color: theme.palette.violetsAreBlue,
    position: 'absolute',
    top: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 5%',
  }

  const pricesWrapperStyle = {
    background: theme.palette.aliceBlue,
    padding: '30px 20px 30px 20px',
  }

  const pricesLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '32px',
    fontWeight: '500',
    textAlign: 'center',
    padding: '0px 0px 30px 0px',
  }

  useEffect(() => {
    const fetchSubscriptionPackagesData = async () => {
      const url = constants.core_service_domain + '/' + subscriptionsURLs.getSubscriptionPackages
      
      const request_data = { url, method: 'GET' }
      
      const response = await publicRequest(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSubscriptionPackagesData(response.data.filter(item => item.group === 'isender'))
      } else {
        setSubscriptionPackagesData([])
      }
    }

    const fetchSubscriptionGroupsData = async () => {
      const url = constants.core_service_domain + '/' + subscriptionsURLs.getSubscriptionGroups
      
      const request_data = { url, method: 'GET' }
      
      const response = await publicRequest(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSubscriptionGroupsData(response.data)
      } else {
        setSubscriptionGroupsData([])
      }
    }

    fetchSubscriptionPackagesData()
    fetchSubscriptionGroupsData()
  }, [])

  useEffect(() => {
    const sortByPriority = (list) => {
      return [...list].sort((a, b) => a.priority - b.priority)
    }

    const getSortedSubscriptions = () => {
      let result = []

      const groups = sortByPriority(subscriptionGroupsData)

      groups.forEach(gr => {
        const filtered_packages = subscriptionPackagesData.filter(pa => pa.group === gr.group_name)
        const sorted_packages = filtered_packages.length > 0 ? sortByPriority(filtered_packages) : []
        sorted_packages.forEach(pa => [
          result.push({
            ...pa,
            group_name: gr.title.value,
          })
        ])
      })

      return result
    }

    if (subscriptionPackagesData.length > 0 && subscriptionGroupsData.length > 0) {
      const sorted_subscriptions = getSortedSubscriptions()
      setSubscriptions(sorted_subscriptions)
    } else {
      setSubscriptions([])
    }
  }, [subscriptionPackagesData, subscriptionGroupsData])

  useEffect(() => {
    if (subscriptions.length > 0) {
      let subscription_slider_data = []

      subscriptions.forEach((item, index) => {
        subscription_slider_data.push(<HomeSubscriptionItem
          key={index}
          index={index}
          {...item}
        />)
      })

      setSubscriptionsSliderData(subscription_slider_data)

      let slides_to_show = 3

      if (width < constants.mdBreakpoint) {
        slides_to_show = 1
      } else if (width < constants.lgBreakpoint) {
        slides_to_show = 2
      } else if (subscriptions.length < 3) {
        slides_to_show = subscriptions.length
      }

      setSubscriptionsSliderSlidesToShow(slides_to_show)
    } else {
      setSubscriptionsSliderData([])
      setSubscriptionsSliderSlidesToShow(0)
    }
  }, [subscriptions, width])

  const getInvoicingScreenshot = () => {
    return (
      <Grid size={{ xs: 12, lg: 5, xl: 4 }} offset={{ xs: 0, xl: 1 }}>
        <Box>
          <Stack
            direction='column'
            alignItems={{ xs: 'center', lg: 'flex-start' }}
            justifyContent='center'
            sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
          >
            <Box>
              <img src={isender_invoicing} alt='' style={imageStyle} />
            </Box>
          </Stack>              
        </Box>
      </Grid>
    )
  }

  const getWebScreenshot = () => {
    return (
      <Grid size={{ xs: 12, lg: 5, xl: 4 }} offset={{ xs: 0, xl: 1 }}>
        <Box>
          <Stack
            direction='column'
            alignItems={{ xs: 'center', lg: 'flex-start' }}
            justifyContent='center'
            sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
          >
            <Box>
              <img src={isender_web} alt='' style={imageStyle} />
            </Box>
          </Stack>              
        </Box>
      </Grid>
    )
  }
  
  return (
    <>
      <Box sx={adminUiWrapperStyle} id='id_products'>
        <Box sx={pageLabelStyle}>{defaultTexts.iSenderApplication}</Box>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          { width >= constants.lgBreakpoint && getInvoicingScreenshot() }
          <Grid size={{ xs: 12, lg: 7, xl: 6 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={adminUiLabel}>{defaultTexts.iSenderInvoicingLabel}</Box>
                <Box sx={adminUiDescription}>{parse(defaultTexts.iSenderInvoicingText)}</Box>
              </Stack>
            </Box>
          </Grid>
          { width < constants.lgBreakpoint && getInvoicingScreenshot() }
        </Grid>
      </Box>

      <Box sx={customerUiWrapperStyle}>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          <Grid size={{ xs: 12, lg: 7, xl: 7 }} offset={{ xs: 0, xl: 1 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={adminUiLabel}>{defaultTexts.iSenderDesignLabel}</Box>
                <Box sx={customerUiDescription}>{parse(defaultTexts.iSenderDesignText)}</Box>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 5, xl: 4 }}>
            <Box>
              <Stack
                direction='column'
                alignItems={{ xs: 'center', lg: 'flex-start' }}
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box>
                  <img src={isender_design} alt='' style={imageStyle} />
                </Box>
              </Stack>              
            </Box>
          </Grid> 
        </Grid>
      </Box>

      <Box sx={adminUiWrapperStyle}>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          { width >= constants.lgBreakpoint && getWebScreenshot() }
          <Grid size={{ xs: 12, lg: 7, xl: 6 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={adminUiLabel}>{defaultTexts.iSenderWebLabel}</Box>
                <Box sx={adminUiDescription}>{parse(defaultTexts.iSenderWebText)}</Box>
              </Stack>
            </Box>
          </Grid>
          { width < constants.lgBreakpoint && getWebScreenshot() }
        </Grid>
      </Box>

      <Box sx={{ padding: '0px 12%', position: 'relative' }} id='id_prices'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={{ width: '100%', height: '100px' }}
        >
          <CustomHomeDivider />
        </Stack>
        <Box sx={pricesLabel}>
          <Box>{defaultTexts.prices}</Box>        
        </Box>
      </Box>

      <Box sx={pricesWrapperStyle}>
        <Box sx={pricesLabelStyle}>{defaultTexts.iSender}</Box>
        {
          subscriptionsSliderData.length > 0 &&
          <CustomSlickSlider
            slides={subscriptionsSliderData}
            arrows={subscriptionSliderArrows}
            slidesToShow={subscriptionsSliderSlidesToShow}
            draggable={true}     
            centerMode={width < constants.mdBreakpoint ? true : false}
            sx={{ margin: width >= constants.mdBreakpoint ? '0px 50px' : '0px' }}
          />
        }
      </Box>
    </>
  )
}

export default HomeProductISender